import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";

/**
 * AddTimeDialog — shared modal used by "Tempo Dato" and "Tempo Avuto".
 * On save, calls onAdd(hoursNum, minutesNum) with sanitized integers.
 */
export default function AddTimeDialog({
  open,
  onOpenChange,
  onAdd,
  title,
  description,
  testId = "add-time-dialog",
}) {
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");

  const sanitize = (v) => v.replace(/[^0-9]/g, "").slice(0, 5);

  const handleSave = () => {
    const h = parseInt(hours || "0", 10);
    const m = parseInt(minutes || "0", 10);
    if (h === 0 && m === 0) return;
    onAdd(h, m);
    setHours("");
    setMinutes("");
    onOpenChange(false);
  };

  const handleCancel = () => {
    setHours("");
    setMinutes("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={testId}
        className="bg-[#0a0a0b] border border-white/10 text-white sm:max-w-md"
      >
        <DialogHeader>
          <DialogTitle className="text-xl font-light tracking-tight text-white">
            {title}
          </DialogTitle>
          {description && (
            <DialogDescription className="text-sm text-zinc-500 tracking-wide">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>

        <div className="grid grid-cols-2 gap-6 mt-4">
          <label className="flex flex-col items-center">
            <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-3">
              Ore
            </span>
            <input
              data-testid={`${testId}-hours`}
              type="text"
              inputMode="numeric"
              value={hours}
              onChange={(e) => setHours(sanitize(e.target.value))}
              placeholder="00"
              className="w-full text-center text-4xl font-mono font-light text-emerald-400 bg-transparent border-b border-white/10 focus:border-emerald-400/60 outline-none py-3 transition-colors placeholder-emerald-400/20"
            />
          </label>

          <label className="flex flex-col items-center">
            <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-3">
              Minuti
            </span>
            <input
              data-testid={`${testId}-minutes`}
              type="text"
              inputMode="numeric"
              value={minutes}
              onChange={(e) => setMinutes(sanitize(e.target.value))}
              placeholder="00"
              className="w-full text-center text-4xl font-mono font-light text-emerald-400 bg-transparent border-b border-white/10 focus:border-emerald-400/60 outline-none py-3 transition-colors placeholder-emerald-400/20"
            />
          </label>
        </div>

        <div className="flex items-center justify-end gap-3 mt-8">
          <button
            data-testid={`${testId}-cancel`}
            type="button"
            onClick={handleCancel}
            className="px-5 py-2 text-[11px] tracking-[0.25em] uppercase text-zinc-500 hover:text-white transition-colors font-mono"
          >
            Annulla
          </button>
          <button
            data-testid={`${testId}-save`}
            type="button"
            onClick={handleSave}
            className="px-6 py-2 text-[11px] tracking-[0.25em] uppercase text-emerald-400 border border-emerald-400/40 rounded-full hover:bg-emerald-400/10 hover:border-emerald-400/70 transition-colors font-mono"
          >
            Salva
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
